// Note: This object provides the content for the Pricing page.
export const plans = {
  // Data for the "Pro Plan" card
  pro: {
    title: "Pro Plan",
    price: "$49",
    description: "Includes all features. Integrated with your API key.",
    features: [ // List displayed in the Pro PlanCard
      "Advanced topical mapping",
      "Content briefs & outlines",
      "Algorithmic content creation",
      "Use your own OpenAI API key",
      "Google Search Console tools",
      "Team collaboration tools"
    ]
  },
  // Data for the "Business Plan" card
  business: {
    title: "Business Plan",
    price: "Custom",
    description: "Tailored solutions for enterprise needs with personalized pricing.",
    baseFeatures: [ // Static features that don't change with the calculator
      "End-to-end content management",
      "Tailored content strategy",
      "Dedicated writing and support team",
      "Dedicated Google Drive"
    ],
    ctaLink: "/contact", // Custom link for this plan
    ctaText: "Contact Us" // Custom button text for this plan
  },
  // Data for the Comparison Table rows
  features: [
    { name: "Knowledge Graph Creator", pro: true, business: true },
    { name: "Advanced Topical Mapping", pro: true, business: true },
    { name: "Content Briefs & Outlines", pro: true, business: true },
    { name: "Algorithmic Content Creation", pro: true, business: true },
    { name: "Google Search Console Tools", pro: true, business: true },
    { name: "Team Collaboration Tools", pro: true, business: true },
    { name: "End-to-End Content Management", pro: false, business: true },
    { name: "Tailored Content Strategy", pro: false, business: true },
    { name: "Dedicated Writing Team", pro: false, business: true },
    { name: "Dedicated Google Drive", pro: false, business: true }
  ]
}